import { Text } from '@cad-arc';

export function FrCreateOrEditEventFormSectionTitle({ title }: { title: string }) {
    return (
        <Text
            fontWeight="semibold"
            fontSize="large"
            color="tertiary"
            style={{ textTransform: 'capitalize' }}
        >
            {title}
        </Text>
    );
}
